'use client'

import { ChevronRight, Bell, Info } from 'lucide-react'

import { formatTimestamp } from '@helpers/format'
import Notification from '@components/Notification'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

const StudentChatListModal = ({ chatSummary, isOpen, closeModal, setSelectedChatId, classroomResearch }) => {
  return (
    <Dialog open={isOpen} onOpenChange={closeModal}>
      <DialogContent className="sm:max-w-[700px]">
        <DialogHeader>
          <DialogTitle>{chatSummary.profile.fullName}'s chats</DialogTitle>
        </DialogHeader>

        <Choose>
          <When condition={classroomResearch && !chatSummary.classroomEnrollment.researchConsent}>
            <Notification className='mb-5'>
              <Info className='size-6 text-blue-500 mr-2' />

              <p className='font-normal'>
                This student's data is not available since they have not consented to participate in research.
              </p>
            </Notification>
          </When>

          <Otherwise>
            <div className="max-h-[60vh] overflow-y-auto border rounded-md">
              <div className="divide-y divide-border">
                <For each='chat' of={chatSummary.chats}>
                  <button
                    key={chat.id}
                    className='flex items-center justify-between w-full cursor-pointer hover:bg-muted/50 py-3 px-4'
                    onClick={() => setSelectedChatId(chat.id)}
                  >
                    <div className='text-left'>
                      <span className="font-medium">{formatTimestamp(chat.createdAt)}</span>

                      <If condition={chat.flaggedByModeration}>
                        <span className='group ml-2 inline-flex items-center bg-destructive/10 text-destructive p-1 rounded-full'>
                          <Bell className='size-4' />
                        </span>
                      </If>
                    </div>

                    <ChevronRight className='w-5 h-5 text-muted-foreground' />
                  </button>
                </For>
              </div>
            </div>
          </Otherwise>
        </Choose>
      </DialogContent>
    </Dialog>
  )
}

export default StudentChatListModal
